import projection from '../generated/pwc203f1.json';
import { AcceptanceManifest } from '../types';

export const pwc203f1AcceptanceManifest = projection as AcceptanceManifest;
